import * as t from "./types";
import * as actions from "./action";

/* Permission & Role */
export const getPermissionsAction = (
  payload: t.GetPermissionsRequestType
): t.GetPermissionsActionType => {
  return {
    type: actions.GET_PERMISSIONS,
    payload,
  };
};

export const getPermissionAction = (
  payload: t.GetPermissionRequestType
): t.GetPermissionActionType => {
  return {
    type: actions.GET_PERMISSION,
    payload,
  };
};

export const getRolesAction = (
  payload: t.GetRolesRequestType
): t.GetRolesActionType => {
  return {
    type: actions.GET_ROLES,
    payload,
  };
};

export const getRoleAction = (
  payload: t.GetRoleRequestType
): t.GetRoleActionType => {
  return {
    type: actions.GET_ROLE,
    payload,
  };
};

export const getRolePermissionsAction = (
  payload: t.GetRolePermissionsRequestType
): t.GetRolePermissionsActionType => {
  return {
    type: actions.GET_ROLEPERMISSIONS,
    payload,
  };
};

export const getRolePermissionAction = (
  payload: t.GetRolePermissionRequestType
): t.GetRolePermissionActionType => {
  return {
    type: actions.GET_ROLEPERMISSION,
    payload,
  };
};
